import {showMessage} from 'exsportia-components'

import {API} from '../../networking/http'
import {MutationMethod} from '../helpers/types'
import {Booking} from './types'

type splitPaymentParticipant = {
  totalPrice?: number
  discount?: number
  equipmentDiscount?: number
  initialDiscount?: number
  isPaid?: boolean
  toPay?: boolean
}

export type BookingSplitPayRequest = {
  venueId: string
  uid: string // used to fetch the booking
  bookingId: string // used to update
  sum: number // used as total payment
  paymentMethodId: string | null // token payment method
  // memberId: string // contact ID
  data: {
    venueId: string
    name?: string
    phone?: string
    email?: string
    userId?: string
    participants: splitPaymentParticipant[]
  }
}

export type PaySplitPaymentBookingParams = undefined
export type PaySplitPaymentBookingMutationParams = BookingSplitPayRequest
export type CreateSplitPaymentDraftBookingMutationParams = BookingSplitPayRequest
export type PaySplitPaymentBookingMutationReturnType = Booking
export type PaySplitPaymentBookingMutation = MutationMethod<
  PaySplitPaymentBookingParams,
  PaySplitPaymentBookingMutationParams,
  PaySplitPaymentBookingMutationReturnType
>

export const updateSplitBookingPayByTokenEndpoint = 'bookings/split/byToken'
export const updateSplitBookingPaySubscriptionEndpoint = 'bookings/split/subscription'
export const createSplitBookingDraftEndpoint = 'bookings/draft'

export const updateServiceBookingSplitPayByTokenMutation: PaySplitPaymentBookingMutation = () => ({
  mutationFn: (bookingDraft) =>
    API.put<PaySplitPaymentBookingMutationParams, PaySplitPaymentBookingMutationReturnType>(
      updateSplitBookingPayByTokenEndpoint,
      bookingDraft,
    )
      .then((res) => res.data)
      .catch((error) => {
        // eslint-disable-next-line
        showMessage(`Error payment booking: ${error?.response?.data?.message ?? 'Payment Failed'}`, 'error')
        throw error
      }),
})

export const updateServiceBookingSplitPaySubscriptionMutation: PaySplitPaymentBookingMutation = () => ({
  mutationFn: (bookingDraft) =>
    API.put<PaySplitPaymentBookingMutationParams, PaySplitPaymentBookingMutationReturnType>(
      updateSplitBookingPaySubscriptionEndpoint,
      bookingDraft,
    )
      .then((res) => res.data)
      .catch((error) => {
        // eslint-disable-next-line
        showMessage(`Error payment booking: ${error?.response?.data?.message ?? 'Payment Failed'}`, 'error')
        throw error
      }),
})

export const createSplitPaymentBookingDraftMutation: PaySplitPaymentBookingMutation = () => ({
  mutationFn: (bookingDraft) =>
    API.post<PaySplitPaymentBookingMutationParams, PaySplitPaymentBookingMutationReturnType>(
      createSplitBookingDraftEndpoint,
      bookingDraft,
    )
      .then((res) => res.data)
      .catch((error) => {
        // eslint-disable-next-line
        showMessage(`Error payment booking: ${error?.response?.data?.message ?? 'Payment Failed'}`, 'error')
        throw error
      }),
})
